import React, { forwardRef, useCallback, useImperativeHandle, useMemo } from 'react';
import clsx from 'clsx';
import {
  withStyles,
  Theme,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  makeStyles,
  Hidden,
} from '@material-ui/core';
import { useWkblVideo } from 'hooks';
import { OrderByOptions, SortOptions, style } from 'commons/constants/KeyFlowConstants';
import { AscType, SortType } from 'commons/constants/type';
import { useSelector } from 'react-redux';
import { RootState, WkblVideoState } from 'redux/reducers/type';
import { OrderOptionsProps, OrderOptionProps } from 'components/SelectOptions/type';

const StyledMenuItem = withStyles((theme: Theme) => ({
  root: {
    '&.Mui-selected': {
      backgroundColor: '#D94F98',
      '& > *': {
        color: '#ffffff',
      },
      '&:hover': {
        '& > *': {
          color: 'black',
        },
      },
    },
    '&:focus': {
      backgroundColor: '#D94F98',
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

function Option({ name, value, icon, isActive, onClick }: OrderOptionProps) {
  const Icon = icon;

  const onClickItem = useCallback(() => {
    onClick(value);
  }, [onClick, value]);

  return (
    <StyledMenuItem onClick={onClickItem} selected={isActive}>
      <Hidden mdDown>
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
      </Hidden>
      <ListItemText>{name}</ListItemText>
    </StyledMenuItem>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  divider: {
    margin: '5px 0',
  },
}));

function OrderOptions({ asc, sort, onClose, onChangeSort, onChangeAsc }: OrderOptionsProps) {
  const classes = useStyles();

  const onClickSort = useCallback(
    (value: SortType) => {
      onChangeSort(value);
      onClose();
    },
    [onChangeSort],
  );

  const onClickOrder = useCallback(
    (value: AscType) => {
      onChangeAsc(value);
      onClose();
    },
    [onChangeAsc],
  );

  return (
    <>
      {OrderByOptions.map(orderOption => (
        <Option isActive={asc === orderOption.value} onClick={onClickOrder} {...orderOption} />
      ))}
      <Divider className={clsx(classes.divider)} />
      {SortOptions.map(sortOption => (
        <Option isActive={sort === sortOption.value} onClick={onClickSort} {...sortOption} />
      ))}
    </>
  );
}

export default OrderOptions;
